export const getPopupContainer = (triggerNode: HTMLElement | Element) => {
    // Wenn das Element in einem Ant Design Modal liegt, document.body verwenden,
    // damit das Popup über dem Modal erscheint (nicht dahinter)
    if (triggerNode.closest && triggerNode.closest(".ant-modal")) {
        return document.body;
    }

    const element = document.querySelector<HTMLElement>("#page");

    // Nicht jede Seite hat #page (z. B. der Kurskalender): sonst stürzt das Öffnen der Auswahl ab
    if (!element) {
        return document.body;
    }

    element.style.position = "relative";

    return element;
};
